export class GdEventReportDto {
  eventId: string;
  email: string;
  fullName: string;
  search: string;
}

export class ResponseGdEventSendEmailDto {
  message: string;
  data?: any;
}


// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/dto/gd-event-report.dto.ts